import { inject, Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'
import { AuthStore } from '../stores/auth.store'
import { createTreeFromURL } from '../utilities/urls'

@Injectable()
export class Authorised {
  private router = inject(Router)
  private authStore = inject(AuthStore)

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const user = await this.authStore.waitForUser()
    if (user) {
      if (route.queryParams['return_url']) {
        return this.router.createUrlTree(
          ...createTreeFromURL(route.queryParams['return_url'])
        )
      }
      return true
    }
    return this.router.createUrlTree(
      ['/log-in'],
      state.url
        ? {
            queryParams: { return_url: state.url },
          }
        : {}
    )
  }
}
